import { useEffect, useState } from 'react';
export function useDelayFlag(delayMs) {
    const [ready, setReady] = useState(false);
    useEffect(() => {
        const timer = setTimeout(() => setReady(true), delayMs);
        return () => clearTimeout(timer);
    }, [delayMs]);
    return ready;
}
//# sourceMappingURL=useDelayFlag.js.map